"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const react_helmet_1 = require("react-helmet");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const AppBar_1 = __importDefault(require("@mui/material/AppBar/AppBar"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const material_1 = require("@mui/material");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const PieChart_1 = __importDefault(require("@mui/icons-material/PieChart"));
const Leaderboard_1 = __importDefault(require("@mui/icons-material/Leaderboard"));
const AccountBalance_1 = __importDefault(require("@mui/icons-material/AccountBalance"));
const categories_1 = require("companion-app-components/flux/categories");
const tags_1 = require("companion-app-components/flux/tags");
// COMPONENTS
const GraphWithRegister_1 = __importDefault(require("containers/NewReports/components/GraphWithRegister"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
// DATA & UTILS
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const types_1 = require("components/QFilterSelect/types");
const selectors_1 = require("data/payees/selectors");
const utils_1 = require("./utils");
const state_1 = require("./state");
const useStyles = (0, mui_1.makeStyles)()(({ palette, typography, components: { appBar, toolBar, report }, shadows, }) => ({
    chartSettingsContainer: {
        margin: 'auto',
    },
    graphContainer: {
        padding: 16,
    },
    root: {
        backgroundColor: palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        maxHeight: 'calc(100vh)',
        overflowY: 'scroll',
    },
    tab: {
        fontSize: 14,
        fontWeight: 500,
        minWidth: 0,
        padding: '6px 9px',
        whiteSpace: 'nowrap',
        '@media (min-width: 960px)': {
            padding: '6px 12px',
        },
        '@media (min-width: 1103px)': {
            padding: '6px 12px',
        },
    },
    titleContainer: {
        padding: '18px 0px 18px 32px',
        borderBottom: `1px solid ${palette.border.primary}`,
    },
    tabsHeader: {
        boxShadow: shadows[2],
    },
    tabsFlexContainer: {
        justifyContent: 'space-between',
        height: 48,
        alignItems: 'center',
        overflow: 'hidden',
        cursor: 'pointer',
        '& > button': {
            maxWidth: 'none !important', // ie-11 needs this
        },
    },
    tabsIndicator: {
        height: 5,
        backgroundColor: report.backgroundColor,
        width: `${100 / 3}% !important`,
    },
    appBar,
    toolBar,
    toolBarContainer: {
        display: 'flex',
        margin: '0 auto',
        paddingLeft: 8,
        paddingRight: 8,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    headerTypography: Object.assign(Object.assign({}, typography.body2), { color: report.headerTypographyColor, fontWeight: 500, fontSize: 13 }),
    tabLabelContainer: {
        padding: 6,
        width: 'auto !important',
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: 'normal',
        color: 'white !important',
        minHeight: 'auto',
    },
    tabWrapper: {
        flexDirection: 'row',
    },
    contentWrapper: {
        padding: '0px 60px',
    },
    spendingToolbarSentinel: {
        height: 2,
    },
}));
const Reports = () => {
    var _a;
    const { classes } = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { tabName = 'spending', layoutView } = (0, react_router_dom_1.useParams)();
    const tabValue = (0, utils_1.convertTabNameToValue)(tabName);
    const [globalState, dispatch] = (0, react_1.useReducer)(state_1.reduceReports, state_1.initialReportsState);
    const rootRef = (0, react_1.useRef)(null);
    const { datasetPreferences } = (0, useQPreferences_1.default)();
    const selectCategoryById = (0, react_redux_1.useSelector)((state) => (id) => categories_1.categoriesSelectors.getCategoryById(state, id));
    const selectTagById = (0, react_redux_1.useSelector)((state) => (id) => tags_1.tagsSelectors.getTagById(state, id));
    const payeesNameList = (0, react_redux_1.useSelector)(selectors_1.getPayeesNameList);
    const handleTabClick = (0, react_1.useCallback)((_event, changeValue) => {
        const newTabName = (0, utils_1.convertTabValueToName)(changeValue);
        let route = `/reports/${newTabName}`;
        const changingGroupBy = (0, utils_1.getDefaultGroupByFromTabName)(newTabName);
        if (changingGroupBy) {
            route += `/by-${changingGroupBy}`;
        }
        const defaultIsOverTimeFromTabName = (0, utils_1.getDefaultIsOverTimeFromTabName)(newTabName);
        if (defaultIsOverTimeFromTabName != null) {
            const changingLayoutView = defaultIsOverTimeFromTabName ? 'over-time' : 'total';
            if (changingLayoutView) {
                route += `/${changingLayoutView}`;
            }
        }
        navigate(route);
        dispatch({ type: 'tabChange', payload: { tabName: newTabName } });
    }, [navigate]);
    const applyFilterToView = () => {
        var _a, _b, _c, _d, _e, _f, _g;
        const filterObject = (_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.reportsViewStates) === null || _a === void 0 ? void 0 : _a.filterObject;
        if (filterObject) {
            const availableCategories = (_c = (_b = filterObject.categories) === null || _b === void 0 ? void 0 : _b.filter) === null || _c === void 0 ? void 0 : _c.call(_b, (categoryId) => Boolean(selectCategoryById(categoryId)));
            const availableTags = (_e = (_d = filterObject.tags) === null || _d === void 0 ? void 0 : _d.filter) === null || _e === void 0 ? void 0 : _e.call(_d, (tagId) => Boolean(selectTagById(tagId)));
            const availablePayees = (_g = (_f = filterObject.payees) === null || _f === void 0 ? void 0 : _f.filter) === null || _g === void 0 ? void 0 : _g.call(_f, (payeeName) => { var _a; return (_a = payeesNameList === null || payeesNameList === void 0 ? void 0 : payeesNameList.find) === null || _a === void 0 ? void 0 : _a.call(payeesNameList, (payee) => { var _a; return ((_a = payee.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (payeeName === null || payeeName === void 0 ? void 0 : payeeName.toLowerCase()); }); });
            const payload = {
                filterObject: new types_1.FilterObject(Object.assign(Object.assign({}, filterObject), { advanced: new types_1.AdvancedFilterObject(filterObject.advanced), categories: (0, immutable_1.Set)(availableCategories), payees: (0, immutable_1.Set)(availablePayees), tags: (0, immutable_1.Set)(availableTags), accounts: (0, immutable_1.Set)(filterObject.accounts), payeeNames: (0, immutable_1.Set)(filterObject.payeeNames) })),
            };
            dispatch({ type: 'update', payload });
        }
    };
    (0, react_use_1.useEffectOnce)(() => {
        dispatch({ type: 'init', payload: { tabName, layoutView } });
        applyFilterToView();
    });
    (0, react_1.useEffect)(() => {
        applyFilterToView();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.reportsViewStates) === null || _a === void 0 ? void 0 : _a.filterObject]);
    const tabClasses = (0, react_1.useMemo)(() => ({
        root: classes.tab,
    }), [classes.tab]);
    const stateContextValue = (0, react_1.useMemo)(() => ({ state: globalState, dispatch }), [globalState, dispatch]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop)
            rootRef.current.scrollTop = 0;
    }, [tabName]);
    (0, react_1.useEffect)(() => {
        if (!layoutView) {
            dispatch({ type: 'tabChange', payload: { tabName } });
        }
    }, [tabName, layoutView]);
    return (<state_1.ReportsStateContext.Provider value={stateContextValue}>
      <react_helmet_1.Helmet>
        <title>{(0, utils_1.convertTabNameToTitle)(tabName)}</title>
      </react_helmet_1.Helmet>
      <AppBar_1.default className={classes.appBar} style={{ zIndex: 9 }}>
        <Toolbar_1.default className={classes.toolBar} id="spendingToolbar">
          {(<div className={classes.toolBarContainer}>
              <div>
                <material_1.Typography variant="h6" id="sot-top-left-header">
                  {(0, utils_1.convertTabNameToTitle)(tabName)}
                </material_1.Typography>
                <div id="sot-top-left-header-secondary" className={classes.headerTypography}>
                  {`${globalState.dateRange.label}: ${globalState.dateRange.value.toFormat('MMM dd, yyyy')}`}
                </div>
              </div>
            </div>)}
        </Toolbar_1.default>
      </AppBar_1.default>
      <div id="spendingToolbarSentinel" className={classes.spendingToolbarSentinel}/>
      <div className={classes.contentWrapper}>
        <RendersCount_1.default id={'newReportsIndex'}/>
        <Paper_1.default elevation={0}>
          <AppBar_1.default position="static" color="primary">
            <Tabs_1.default value={tabValue} onChange={handleTabClick} variant="fullWidth" textColor="inherit" className={classes.tabsHeader} classes={{
            indicator: classes.tabsIndicator,
            flexContainer: classes.tabsFlexContainer,
        }}>
              <Tab_1.default label="Spending" id="spending-tab" classes={{
            wrapper: classes.tabWrapper,
            root: classes.tabLabelContainer,
        }} iconPosition="start" icon={<PieChart_1.default />}/>
              <Tab_1.default label="Net Income" id="income-tab" classes={tabClasses} iconPosition="start" icon={<Leaderboard_1.default />}/>
              <Tab_1.default label="Income vs. Expense" id="net-income-tab" classes={tabClasses} iconPosition="start" icon={<AccountBalance_1.default />}/>
            </Tabs_1.default>
          </AppBar_1.default>
          {['spending',
            'income',
            'net-income',
            'savings',
            'net-worth'].includes(tabName) &&
            <>
            </>}
        </Paper_1.default>
        <GraphWithRegister_1.default />
      </div>
    </state_1.ReportsStateContext.Provider>);
};
exports.default = Reports;
